module.exports = __webpack_public_path__ + "static/img/Jason-Saab.38aaf56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Jason-Saab.jpg
// module id = jSEu
// module chunks = 0